const initialState = {
	sidebarIsOpen: false,
	filterIsOpen: false,
	filterIsAnimating: false,
	achiveLayoutIsWide: true
}


const Sidebar = (state = initialState, action) => {
	switch(action.type) {
		case 'TOGGLE_SIDEBAR':
			return {
				...state,
				sidebarIsOpen: !state.sidebarIsOpen
			}

		case 'CLOSE_SIDEBAR':
			return {
				...state,
				sidebarIsOpen: false
			}

		case 'TOGGLE_FILTER':
			return {
				...state,
				filterIsOpen: !state.filterIsOpen
			}

		case 'CLOSE_FILTER':
			return {
				...state,
				filterIsOpen: false,
				achiveLayoutIsWide: true
			}

		case 'FILTER_IS_ANIMATING':
			return {
				...state,
				filterIsAnimating: action.val
			}

		case 'SET_ARCHIVE_LAYOUT_TO_WIDE':
			return {
				...state,
				achiveLayoutIsWide: action.val
			}

		default:
			return state
	}
}

export default Sidebar